<!--  -->
<template>
  <div style="padding:10px">
    <div class="selectr_box">
      <div class="select_small">
        <el-input
          v-model="timepushlistquery.title"
          placeholder="请输入标题"
          style="width:300px"
        />
        <el-input
          v-model="timepushlistquery.jump_no"
          placeholder="编号"
          style="width:300px;margin-left:10px;"
        />
        <!-- <el-select
          v-model="timepushlistquery.platform_id"
          style="margin-left:10px;"
          filterable
          placeholder="请选择平台"
        >
          <el-option
            v-for="item in accoutarr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select> -->
        <el-select
          v-model="timepushlistquery.onlyMe"
          style="margin-left:10px"
          placeholder="请选择"
        >
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="reast"
        >重置</el-button>
      </div>
      <!-- <div style="text-align: right">
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addtimingw"
        >新增跳转链接</el-button>
      </div> -->
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="jump_no"
        label="编号"
        width="180"
      />
      <el-table-column
        align="center"
        prop="title"
        label="标题"
        width="170"
      />
      <!-- <el-table-column
        prop="web_host_url"
        align="center"
        label="一级链接"
        width="450"
      >
        <template slot-scope="scope">
          {{ scope.row.web_host_url }}<i
            v-if="scope.row.web_host_url!=''"
            v-clipboard:copy="scope.row.web_host_url"
            v-clipboard:success="cowe"
            v-clipboard:error="onError"
            style="margin-left: 5px;color: #E6A23C;cursor: pointer;"
            class="el-icon-document-copy"
          />
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="tagGroupNames"
        label="二级链接"
        width="400"
      >
        <template slot-scope="scope">

          <div
            v-for="item,index in scope.row.secondary_url"
            :key="index"
            style="margin-bottom: 5px;"
          >
            <el-tag>{{ item }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="tagGroupNames"
        label="屏蔽链接"
        width="400"
      >
        <template slot-scope="scope">

          <div
            v-for="item,index in scope.row.shield_secondary_url"
            :key="index"
            style="margin-bottom: 5px;"
          >
            <el-tag>{{ item }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="tagGroupNames"
        label="屏蔽城市"
        width="400"
      >
        <template slot-scope="scope">

          <div class="tag-container">
            <el-tag
              v-for="e,i in JSON.parse(scope.row.shield_region)"
              :key="i"
              style="margin: 2px;"
            >{{ e }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="jump_status_text"
        label="状态"
        width="110"
      />
      <el-table-column
        align="center"
        prop="created_at_text"
        label="创建时间"
        width="170"
      />
      <el-table-column
        align="center"
        prop="created_at_text"
        fixed="right"
        width="170"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="choose(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="二级跳转"
      :visible.sync="accoutlistview"
      :destroy-on-close="true"
      width="900px"
    >
      <surrdialog
        ref="surrdialogview"
        @updata="updata"
      />
    </el-dialog>
    <pagination-right
      :current-page="timepushlistquery.page"
      :total="tableDatatotal"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { stoppush, strategyPlatform } from '@/api/sourceMaterial.js'
import { secondaryJumplist, secondaryJumpdel } from '@/api/bserw.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import surrdialog from './components/surrdialog.vue'
// import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight
    /*     surrdialog */
  },
  mixins: [/* convertToHump */],
  data() {
    return {
      timepushlistquery: {
        page: 1,
        pageSize: 10,
        // task_name: '',
        // relation_id: '',
        // platform_id: null,
        title: '',
        jump_no: '',
        onlyMe: 2
      },
      accoutarr: [],
      tableData: [],
      accountarr: [
        {
          value: 1,
          label: '组内创建'
        },
        {
          value: 2,
          label: '我创建的'
        }
      ],
      tableDatatotal: null,
      accoutlistview: false
    }
  },
  activated() {
    this.gettimepushlist()
  },
  created() {
    this.gettimepushlist()
    // this.getstrategyplatform()
  },
  mounted() {},
  methods: {
    send() {
      this.gettimepushlist()
    },
    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    async gettimepushlist() {
      const data = await secondaryJumplist(this.timepushlistquery)
      this.tableData = data.data.list
      // this.tableData = this.convertToHump(data.data.list)
      this.tableDatatotal = data.data.total
      console.log('data', data)
    },
    search() {
      this.timepushlistquery.page = 1
      this.gettimepushlist()
    },
    reast() {
      this.timepushlistquery = {
        page: 1,
        pageSize: 10,
        // task_name: '',
        // relation_id: '',
        // platform_id: null,
        title: '',
        jump_no: '',
        onlyMe: 2
      }
      this.gettimepushlist()
    },
    fetchPageSizeone(e) {
      this.timepushlistquery.pageSize = e
      this.gettimepushlist()
    },
    fetchCurrentPageone(e) {
      this.timepushlistquery.page = e
      this.gettimepushlist()
    },
    async tingyong(item) {
      this.$confirm('确定要停止推送吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        stoppush({ task_no: item.taskNo }).then(data => {
          if (data.code === 200) {
            this.$message({
              message: '停用成功',
              type: 'success'
            })
            this.gettimepushlist()
          }
        })
      })
    },
    lookaccount(item) {
      console.log(item)
      this.accoutlistview = true
      this.$nextTick(() => {
        this.$refs.accoutlistbox.send(item.taskNo)
      })
    },
    addtimingw() {
      this.accoutlistview = true
      this.$nextTick(() => {
        this.$refs.surrdialogview.send(1)
      })
    },
    updata() {
      this.accoutlistview = false
      this.gettimepushlist()
    },
    edit(item) {
      this.accoutlistview = true
      this.$nextTick(() => {
        this.$refs.surrdialogview.send(2, item)
      })
    },
    cowe() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    },
    deltert(id) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        secondaryJumpdel({ id: id }).then(data => {
          if (data.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.gettimepushlist()
          }
        })
      })
    },
    choose(item) {
      console.log(item)
      this.$emit('hfiveviewcallback', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tab_box {
  padding: 30px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.selectr_box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
.tag-container {
  max-height: 200px;
  overflow: auto;
  /* text-overflow: ellipsis; */
}
.select_small {
  display: flex;
  align-items: center;
}
</style>
